export default __webpack_public_path__ + "static/media/3.16bf9d01.png";